export default __webpack_public_path__ + "static/media/DENTALREFERRAL.41cfb83b.png";